/* eslint-disable max-len */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Features from './Features';
import SubscriptionDetails from '../../../components/SubscriptionDetails';
import AutoRenewalSettings from './AutoRenewalSettings';
import { UserContext } from '../../../contexts/User';
import { useMembershipName } from '../../../hooks/useMembershipName';

function Overview({ setTab }) {
  const { activeWorkspace } = useContext(UserContext);
  const membershipName = useMembershipName(activeWorkspace.membership);

  return (
    <div className="p-6" style={{ fontFamily: 'Inter, sans-serif' }}>
      <SubscriptionDetails
        workspaceId={activeWorkspace.id}
        showUpgradePrompt
        fallbackContent={(
          <>
            <h5 className="text-base font-semibold text-ink-900 mb-2">{`Your workspace is on the ${membershipName} Plan`}</h5>
            <p className="text-sm text-ink-700 mb-3">
              {'Upgrade to the '}
              <strong>Basic, Team, Professional</strong>
              {' or '}
              <strong>Enterprise</strong>
              {' plan for unlimited access to features, including:'}
            </p>
            <Features />
          </>
        )}
      />

      <div className="mt-4">
        <button
          type="button"
          onClick={() => setTab(1)}
          className="inline-flex items-center justify-center box-border h-10 px-4 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] transition"
        >
          Upgrade Your Workspace
        </button>
      </div>

      <div style={{ height: 1, background: '#e0e1e6', margin: '24px 0' }} />

      <AutoRenewalSettings workspaceId={activeWorkspace.id} />
    </div>
  );
}

Overview.propTypes = { setTab: PropTypes.func };
Overview.defaultProps = { setTab: () => {} };

export default Overview;
